import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { TratamientoDeParametroParaURI } from '../../Varios';

export const function_VEN_ListasPrecios_Cabecera_Listar = async () => {
    const NombreFuncion = "function_VEN_ListasPrecios_Cabecera_Listar"

    try {
        const resulData = await llamadaAPI_GET("VEN_ListasPrecios_Cabecera/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_ListasPrecios_Cabecera_ListarVigentes = async () => {
    const NombreFuncion = "function_VEN_ListasPrecios_Cabecera_ListarVigentes"

    try {
        const resulData = await llamadaAPI_GET("VEN_ListasPrecios_Cabecera/ListarVigentes/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_ListasPrecios_Cabecera_Leer = async (CodigoListaPrecios, FechaComienzo) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Cabecera_Leer"

    try {
        const resulData = await llamadaAPI_GET("VEN_ListasPrecios_Cabecera/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoListaPrecios) + "/" +
            FechaComienzo);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_ListasPrecios_Cabecera_ListarFechasVigentes = async (CodigoListaPrecios) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Cabecera_ListarFechasVigentes"

    try {        
        const resulData = await llamadaAPI_GET("VEN_ListasPrecios_Cabecera/ListarFechasVigentes/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoListaPrecios));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_ListasPrecios_Cabecera_Generar_JSON = async (CodigoListaPrecios, CodigoMoneda, FechaComienzo, FechaFin, Descripcion, MultiPlanta,
    MultiEmpresa, SinFinalizacion, EsPorcentual, CodigoListaPreciosBasePorcentual) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Cabecera_Generar_JSON";

    try {

        const JSON = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            CodigoListaPrecios: CodigoListaPrecios, 
            CodigoMoneda: CodigoMoneda, 
            FechaComienzo: FechaComienzo, 
            FechaFin: FechaFin, 
            Descripcion: Descripcion, 
            MultiPlanta: MultiPlanta,
            MultiEmpresa: MultiEmpresa, 
            IdEstado: 10,
            SinFinalizacion: SinFinalizacion, 
            EsPorcentual: EsPorcentual, 
            CodigoListaPreciosBasePorcentual: CodigoListaPreciosBasePorcentual
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_ListasPrecios_Cabecera_Insertar = async (ListaPrecios) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Cabecera_Insertar";

    try {
        const docVentaResult = await llamadaAPI_POST("VEN_ListasPrecios_Cabecera/Insertar/",
            ListaPrecios);
        return docVentaResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_ListasPrecios_Cabecera_Modificar = async (ListaPrecios) => {
    const NombreFuncion = "function_VEN_ListasPrecios_Cabecera_Modificar";

    try {
        await llamadaAPI_PUT("VEN_ListasPrecios_Cabecera/Modificar/",
            ListaPrecios);
        return true;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};